export function suggestPlannedVolume(kpi, budget, price) {
    const b = Number(budget);
    const p = Number(price);
    if (!kpi || isNaN(b) || isNaN(p) || b <= 0 || p <= 0) {
        return null;
    }

    const pm = String(kpi).toUpperCase();
    if (pm === 'CPM') {
        return Math.floor((b / p) * 1000);
    }
    if (pm === 'CPC' || pm === 'CPV' || pm === 'CPE') {
        return Math.floor(b / p);
    }

    return Math.floor((b / p) * 1000);
}

export function volumeUnitKey(kpi) {
    const pm = String(kpi || '').toUpperCase();
    if (pm === 'CPC') return 'volume_unit_clicks';
    if (pm === 'CPV') return 'volume_unit_views';
    if (pm === 'CPE') return 'volume_unit_events';
    return 'volume_unit_impressions';
}

export function volumeUnitLabel(kpi, t) {
    const key = volumeUnitKey(kpi);
    return typeof t === 'function' ? t(`messages.${key}`) : key;
}

export function formatPlannedVolume(volume, kpi, t) {
    if (volume === null || volume === undefined || volume === '') {
        return '—';
    }
    const nf = new Intl.NumberFormat('ru-RU');
    const unit = volumeUnitLabel(kpi, t);
    return `${nf.format(Number(volume))} ${unit}`;
}
